<template>
  <blank-layout :participant="participant">
    <div class="mt-12 sm:mt-0 px-4 py-5 flex flex-col items-center justify-center w-full">
      <div class="min-w-0 flex-1 h-full max-w-sm mx-auto  px-4 select-none ">
        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mt-12 mb-12" />

        <div class="text-left mt-6">

          <h1 class="mb-6 font-extralight text-xl">Impressum</h1>

          <div v-if="imprint_text">
            <p v-html="imprint_text" class="mb-4 text-xs"></p>

            <p class="mb-4 text-xs">und</p>
          </div>

          <div v-if="text.length > 0" v-html="text" class=" text-xs"></div>

        </div>

      </div>


    </div>

  </blank-layout>
</template>

<script>
import BlankLayout from '@/Pages/DiyWorkshop/Shared/BlankLayout';
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    BlankLayout,
    HorizontalDivider,
  },

  props: {
    participant: {
      type: Object,
      required: true,
    },

    imprint_text: {
      type: String,
      required: false,
      default: '',
    },

    text: {
      type: String,
      required: false,
      default: '',
    }
  },
};
</script>